/**
 * Coupon Repository Interface
 * 쿠폰 관리 데이터 레이어의 추상화 인터페이스
 */
export class ICouponRepository {
  /**
   * 쿠폰 생성
   * @param {Object} data - 쿠폰 생성 데이터
   * @param {number} data.pharmacy_id - 발행 약국 ID
   * @param {string} data.coupon_type - 쿠폰 타입 (DISCOUNT, POINT, FREE)
   * @param {string} data.discount_type - 할인 타입 (FIXED, PERCENT)
   * @param {number} data.amount - 할인/포인트 금액
   * @param {string} [data.description] - 쿠폰 설명
   * @param {number} [data.user_id] - 대상 고객 ID (NULL이면 공용 쿠폰)
   * @param {string} data.scope_type - 쿠폰 사용 범위 (PHARMACY, PHARM_CODE, BRANCH_CODE, ALL)
   * @param {number} data.expiry_days - 유효기간 (일)
   * @returns {Promise<BaseResponse<any>>}
   */
  async createCoupon(data) {
    throw new Error('Method must be implemented');
  }

  /**
   * 쿠폰 목록 조회
   * @param {Object} params - 쿼리 파라미터
   * @param {number} [params.pharmacy_id] - 약국 ID
   * @param {string} [params.scope_type] - 쿠폰 범위 타입 필터
   * @param {boolean} [params.is_active] - 활성화 상태 필터
   * @param {number} [params.limit=50] - 조회 개수
   * @param {number} [params.offset=0] - 오프셋
   * @returns {Promise<BaseResponse<any>>}
   */
  async getCoupons(params) {
    throw new Error('Method must be implemented');
  }

  /**
   * 쿠폰 상세 조회
   * @param {number} couponId - 쿠폰 ID
   * @returns {Promise<BaseResponse<any>>}
   */
  async getCouponById(couponId) {
    throw new Error('Method must be implemented');
  }

  /**
   * 사용자별 쿠폰 목록 조회
   * @param {number} userId - 사용자 ID
   * @param {Object} params - 쿼리 파라미터
   * @param {boolean} [params.is_active] - 활성화 상태 필터
   * @param {number} [params.limit=50] - 조회 개수
   * @param {number} [params.offset=0] - 오프셋
   * @returns {Promise<BaseResponse<any>>}
   */
  async getCouponsByUserId(userId, params) {
    throw new Error('Method must be implemented');
  }

  /**
   * 타겟팅별 대상자 수 조회
   * @param {string} pharmacyId - 약국 사업자등록번호
   * @param {Object} params - 쿼리 파라미터
   * @param {string} [params.target_gender] - 타겟 성별 (ALL, MALE, FEMALE)
   * @param {string} [params.target_ages] - 타겟 연령대 (쉼표 구분, 예: "10,20,30")
   * @returns {Promise<BaseResponse<any>>}
   */
  async getEligibleCount(pharmacyId, params) {
    throw new Error('Method must be implemented');
  }

  async getPharmacyHistory(pharmacyId, params) {
    throw new Error('Method must be implemented');
  }

  async getTemplates() {
    throw new Error('Method must be implemented');
  }

  async createTemplate(data) {
    throw new Error('Method must be implemented');
  }

  async deleteTemplate(templateId) {
    throw new Error('Method must be implemented');
  }

  async getConditions() {
    throw new Error('Method must be implemented');
  }

  async getRecommendedTargetGroups() {
    throw new Error('Method must be implemented');
  }

  async getTargetGroups() {
    throw new Error('Method must be implemented');
  }

  async createTargetGroup(data) {
    throw new Error('Method must be implemented');
  }

  async updateTargetGroup(groupId, data) {
    throw new Error('Method must be implemented');
  }

  async deleteTargetGroup(groupId) {
    throw new Error('Method must be implemented');
  }
}
